window.integerOnly = function (evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
        return false;
    }
    if (evt.which === 8 && evt.target.value.length < 1) {
        evt.target.value = "";
        return false;
    }
    return true;
};
